module.exports = __webpack_public_path__ + "static/media/why_fr_ca.04300aa6.vtt";